import { StyleSheet, View } from "react-native"
import { useStyle } from "react-native-style-utilities"

import { testIds } from "@/theme"

import type { ViewProps } from "@/theme"

const styles = StyleSheet.create({ root: { flex: 1 } })

/**
 * Fills the screen and applies test id
 */
export default function ScreenView({ id, style, ...rest }: ViewProps) {
  return (
    <View
      {...testIds(id)}
      style={useStyle(() => [styles.root, style], [style])}
      {...rest}
    />
  )
}
